<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 14,
            title: "CONTRIBUCIONES, CUOTAS COMPENSATORIAS, GRAVAMENES Y DERECHOS",
            columns: ["clave", "descripcion", "abreviatura", "nivel", "grupo", "actions"],
            options: {
                filterable: ["clave", "descripcion", "abreviatura", "nivel", "grupo"],
                sortable: ["clave", "descripcion", "abreviatura", "nivel", "grupo"],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    abreviatura: "Abreviatura",
                    nivel: "Nivel",
                    grupo:"Grupo Contribución",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                Abreviatura: "abreviatura",
                "Grupo Contribución":"grupo",
                Nivel: "nivel"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                abreviatura: "abreviatura",
                grupo:"Grupo Contribución",
                nivel: "nivel"
            },
            camposLayout: [{
                clave: "[Clave del Tipo de Contribución]",
                descripcion: "[Descripción del Tipo de Contribución]",
                abreviatura: "[Abreviatura del Tipo de Contribución]",
                nivel: "[Nivel del Tipo de Contribución]",
                grupo: "[Grupo al que pertenece la contribución]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: "",
                abreviatura: "",
                nivel: "",
                grupo:""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 10
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 200
                },
                abreviatura: {
                    requiered: true,
                    label: "Abreviatura",
                    value: "",
                    maxlen: 100
                },
                nivel: {
                    requiered: true,
                    label: "Nivel",
                    value: "",
                    maxlen: 100
                },
                grupo: {
                    requiered: true,
                    label: "Grupo Contribución",
                    value: "",
                    maxlen: 20
                },
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>